import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

/**
 * Runtime validation of the Vite-injected env. Throws at module load, before
 * React mounts, so a missing `VITE_API_BASE_URL` is caught at boot instead of
 * surfacing as an opaque network error later.
 */
export const env = createEnv({
  clientPrefix: "VITE_",
  client: {
    VITE_DEV_TENANT_SLUG: z.string().min(1).default("acme"),
    VITE_API_BASE_URL: z.string().url(),
  },
  runtimeEnv: import.meta.env,
  emptyStringAsUndefined: true,
});
